module.exports = __webpack_public_path__ + "img/icon17.654ac317.662872bb.svg";